var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"c-shared-tips-discocer-info-copy",class:{ 'c-shared-tips-discocer-info-copy--vertical': _vm.isVertical }},[_c('p',[_vm._v(_vm._s(_vm.copy))])])}
var staticRenderFns = []

export { render, staticRenderFns }